import axios from "../axios";

const handle = async function (accessToken, uuid, cmd) {
    try {
        const response = await axios.post('/bank-account/handle',{
            cmd
        }, {
            params: {
                uuid
            },
            headers: {
                'Authorization': accessToken
            }
        });
        return response.data;
    }
    catch (e) {
        return {
            success: false,
            errorCode: e.response.status
        }
    }
}

export default handle;
